/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-26T12:46:08+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-27T12:40:28+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * AErrorInput - …
**/

class AErrorInput extends Component {
  render() {
    const {
      children,
    } = this.props;
    return (
      <li className="a-error a-error-input">
        {children}
      </li>
    	);
  }
}
AErrorInput.propTypes = {
  children: PropTypes.any,
};
AErrorInput.defaultProps = {};
export default AErrorInput;

